import { render } from "./Subject_management.vue?vue&type=template&id=2c80d1b0&scoped=true"
import script from "./Subject_management.vue?vue&type=script&lang=js"
export * from "./Subject_management.vue?vue&type=script&lang=js"

import "./Subject_management.vue?vue&type=style&index=0&id=2c80d1b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c80d1b0"]])

export default __exports__